import HomeIcon from '@mui/icons-material/Home'
import { Box, Button, Paper, Typography } from '@mui/material'
import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useGetMonitoringMetricsQuery } from '../../../../api-services/solar/solarApi'
import ErrorComponent from '../../../components/ui-widgets/ErrorComponent'
import LoadingComponent from '../../../components/ui-widgets/LoadingComponent'

const SolarMonitoringMetricsPage: React.FC = () => {
  const history = useHistory()
  const getMetricsApiResult = useGetMonitoringMetricsQuery({})

  const goTo = (location: string): void => {
    history.push(location)
  }

  const columns: GridColDef[] = [
    { field: 'monitoringMetricId', headerName: 'Project ID', flex: 10 },
    { field: 'metricCategory', headerName: 'Metric Category', flex: 15 },
    { field: 'code', headerName: 'Code', flex: 15 },
    { field: 'unit', headerName: 'Unit', flex: 15 },
    { field: 'availableResolutions', headerName: 'Available Resolutions', flex: 15 },
     
    { field: 'externalSystemSyncEnabled', headerName: 'Sync Enabled', flex: 10, headerAlign: 'center', align: 'center', valueGetter: (params) => params.row.externalSystemSyncEnabled ? 'Y' : '' }
  ]
  return (
    <>
      <Box sx={{ mb: 4, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Typography variant={'h4'}>Solar Monitoring Metrics</Typography>
        <Button variant={'text'} type="button" onClick={() => { goTo('/app/solar-engineering-area') }}>
          <HomeIcon style={{ color: '#444' }} />
        </Button>
      </Box>
      <Paper>
        <Box sx={{ p: 4, mt: 3 }}>
          { getMetricsApiResult.isLoading && <LoadingComponent />}
          { getMetricsApiResult.isError && <ErrorComponent message={RtkQueryHelper.mapResponseError(getMetricsApiResult.error)} />}
          { getMetricsApiResult.isSuccess && (
            <DataGrid
              rows={getMetricsApiResult.data}
              getRowId={(row) => row.monitoringMetricId}
              columns={columns}
              autoHeight={true}
              disableSelectionOnClick

              pagination
              pageSize={15}
              rowsPerPageOptions={[15]}
            />
          )}
        </Box>
      </Paper>
    </>
  )
}

export default SolarMonitoringMetricsPage
